<template>
  <div class="jobs">

    <Hero
      title="Vagas<br />Disponíveis"
      image="banner-home.jpeg"
      :search="false"
      layout="md"
      class="darker"
    />


    <div class="row">
      <div class="col-11 col-lg-9 mx-auto">
        <Jobs :key="$route.fullPath" />
      </div>
    </div>

  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import Jobs from "@/components/jobs/Jobs.vue";

export default {
  name: "JobsList",

  data() {
    return {
    }
  },

  computed: {
  },

  components: {
    Hero,
    Jobs
  },
};
</script>

<style lang="scss" scoped>
  .jobs{
    padding-top: 80px;
  }
</style>